import _ from 'underscore';
import ko from 'knockout';
import { KoSchema } from '@bingads-webui/ko-schema';
import { Validation } from '@bingads-webui/validation';
import { controlSpecified } from './control/index';
import { generate } from './control/readonly-computed';
import { isEditing } from '../service/status';

export class SimpleFormViewModel {
  /**
   * construct simple form view model
   * @param {FieldOpetion[]} fields - field options for properties
   * @param {JsonSchema} schema - entity define
   * @param {Object} model - value of entity
   * @param {customValidators} customValidators - customized validators
   * @param {I18n} i18n - provide i18n for KoSchema and Validation
   * @returns {void}
   */
  constructor({
    fields,
    schema,
    model,
    customValidators,
    i18n,
  }) {
    const properties = _.pluck(fields, 'property');

    KoSchema(this, schema, properties, model, customValidators, i18n);

    _.each(fields, (field) => {
      const {
        value, property, control, validators,
      } = field;

      if (value) {
        this[property] = generate(value, this).extend({
          validate: [Validation.passive(i18n)],
        });
      }

      if (_.isUndefined(this[property])) {
        this[property] = ko.observable();
      }

      const observable = this[property];
      const propertySchema = schema.properties[property];
      controlSpecified(control.builtInControl, observable, propertySchema, field, this);

      if (_.has(observable, 'validators')) {
        _.each(validators, (config, name) => {
          const validator = observable.validators[name];

          if (validator) {
            _.extend(validator, config);
          }
        });
      }
    });

    const validator = Validation.passive(i18n);

    this.$overall = ko.observable().extend({
      validate: [validator],
    });

    this.$overall.validators = { passive: validator };

    this.editing = isEditing(schema, model);
  }
}
